import type { UserPreferencesSpmTabsChanged } from './tabOrder.action';
import type { TabsOrderType } from './tabOrder.model';

export function tabOrdersReducer(
  state: TabsOrderType = { spmVisible: [], spmHidden: [] },
  action: UserPreferencesSpmTabsChanged,
): TabsOrderType {
  switch (action.type) {
    case 'USER_PREFERENCES_SPMTABS_UPDATED':
      return { spmVisible: action.visibleTabs, spmHidden: action.hiddenTabs };
    default:
      return state;
  }
}
